import React, { useState, useEffect, useRef } from 'react'
import { Button, Col } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import moment from 'moment'
import AntdTable from '@/components/table/AntdTable'
import { formatMessageNew, paginationInit, downLoadFileBlob } from '@/utils/common'
import { getAllTunnelMachineCode } from '@/services/rfid/rfidConfig/rfidStore'
import {
  getchannelMachineStatusRfid,
  channelMachineStatusExportRfid
} from '@/services/rfid/rfidDashboard/rfidDashboard'
import SearchBar from '@/components/searchbar/SearchBar'

const dateFormat = 'YYYY-MM-DD'
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs()

const RFIDChannelModalTable = props => {
  let languageState = useSelector(state => state.commonStore.language)
  let tunnel = props.selectItem && props.selectItem.tunnelMachine
  tunnel = tunnel ? [tunnel] : []
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.rfidDashboard.tunnelMachineId',
      key: 'tunnelMachines',
      initialValues: tunnel,
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.rfidDashboard.timeDate',
      key: 'timeDate',
      format: dateFormat,
      disabledDate: current => {
        let falg = (current && current < moment().subtract(7, 'day')) || (current && current > moment().endOf('day'))
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.rfidDashboard.tunnelMachineId'),
      dataIndex: 'tunnelMachine',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.statusCode'),
      dataIndex: 'statusCode',
      width: 50,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.description'),
      dataIndex: 'description',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.time'),
      dataIndex: 'lastUpdatedTime',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]

  const [pagination, setPagination] = useState(paginationInit)
  const [tableList, setTableList] = useState([])
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  let formRef = useRef(null)

  useEffect(() => {
    searchTunnelMachine()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getTableList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    formRef &&
      formRef.current.setValue({
        tunnelMachines: [],
        timeDate: []
      })
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchTunnelMachine = () => {
    const params = {}

    getAllTunnelMachineCode(params).then(res => {
      searchList.forEach(itemFirst => {
        const arr = []
        if (itemFirst.key === 'tunnelMachines') {
          const records = res.resultData || []
          for (let index = 0; index < records.length; index++) {
            const element = records[index]
            arr.push({
              label: element,
              value: element
            })
          }
          itemFirst.selectList = arr
        }
      })
      setSearchList([...searchList])
    })
  }

  const getTableList = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    let timeDate = info.timeDate
    let startTime = timeDate && timeDate[0] ? timeDate[0].format(dateFormat) : startMonth.format(dateFormat)
    let endTime = timeDate && timeDate[1] ? timeDate[1].format(dateFormat) : endMonth.format(dateFormat)
    let params = {
      asc: true,
      // orderByColumn: '',
      current: pagination.currentPage,
      size: pagination.pageSize,
      param: {
        startTime: startTime,
        endTime: endTime,
        tunnelMachines: info.tunnelMachines
      }
    }
    getchannelMachineStatusRfid(params).then(res => {
      if (res.resultData) {
        setTableList(res.resultData.records || [])
        const pg = {
          ...pagination,
          total: res.resultData.total
        }
        setPagination(pg)
      }
    })
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const downLoadFun = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    let timeDate = info.timeDate
    let startTime = timeDate && timeDate[0] ? timeDate[0].format(dateFormat) : startMonth.format(dateFormat)
    let endTime = timeDate && timeDate[1] ? timeDate[1].format(dateFormat) : endMonth.format(dateFormat)
    const params = {
      isChinese: languageState === 'zh_CN' ? true : false,
      startTime: startTime,
      endTime: endTime,
      tunnelMachines: info.tunnelMachines
    }
    channelMachineStatusExportRfid(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  return (
    <div>
      <div className="search-bar">
        <SearchBar ref={formRef} searchList={searchList}>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="right_search"
            style={{ justifyContent: 'flex-end' }}
          >
            <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
              {formatMessageNew('languageObj.commonLocale.search')}
            </Button>
            <Button onClick={searchClearDataBtn}>{formatMessageNew('languageObj.commonLocale.clear')}</Button>
            <Button type="primary" onClick={downLoadFun}>
              {formatMessageNew('languageObj.commonLocale.download')}
            </Button>
          </Col>
        </SearchBar>
      </div>
      <div className="content-container mt15">
        <AntdTable dataSource={tableList} columns={tableColumns} pagination={pagination} onChange={handleTableChange} />
      </div>
    </div>
  )
}
export default RFIDChannelModalTable
